import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
var JsBarcode = require("jsbarcode");
let pgsHelper = new PGSHelper();
import Currencies from "../Currencies.js";
export default class ReporteZ {
  monedaDefault = "";
  columnas = 3;
  filas = 10;
  margins = 0;
  h = 1;
  w = 2.6;
  inch = 71.729;
  codesByProd = 1;
  colInit = 1;
  filaInit = 1;
  constructor(data) {
    this.columnas = data.columnas;
    this.filas = data.filas;
    this.margins = 0;
    this.h = data.h;
    this.w = data.w;
    this.inch = 71.729;
    this.codesByProd = data.codeByprod;
    this.colInit = data.colInit;
    this.filaInit = data.filaInit;
  }

  async getDocData(mainData) {
    //let getTable = this.getPageCodes();
    let getCols = await this.getPageCodesV2(mainData.data);
    let colH = 100 / Number(this.columnas);
    let widths = [];
    for (var c = 0; c < Number(this.columnas); c++) {
      widths.push(this.w * this.inch);
    }
    let docDefinition = {
      pageMargins: [12, 36, 12, 36],
      pageSize: "LETTER",
      content: [
        //header
        /*  {
          columns: [
            {
              // fixed width
              width: '100%',
              table: {
                widths: widths,
                heights:this.h * 28.3465,
                body: getTable
              }
            },
          ],
          // optional space between columns

        },*/
        getCols,
      ],
    };
    return docDefinition;
  }
  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  }
  async genData(codigoBarras) {
    const { DOMImplementation, XMLSerializer } = require("xmldom");
    const xmlSerializer = new XMLSerializer();
    const document = new DOMImplementation().createDocument(
      "http://www.w3.org/1999/xhtml",
      "html",
      null
    );
    const svgNode = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );

    JsBarcode(svgNode, codigoBarras, {
      xmlDocument: document,
    });

    const svgText = xmlSerializer.serializeToString(svgNode);
    const encodedData = window.btoa(svgText);
    let data = await this.getBase64ImageFromURL(
      "data:image/svg+xml;base64," + encodedData
    );
    return data;

    //return 'data:image/jpeg;base64,'+encodedData;
  }

  getCodesToPrint(productos) {
    let codes = [];
    
    productos.forEach((prod) => {
      for (var i = 0; i < Number(this.codesByProd); i++) {
        codes.push({
          Nombre: prod.Nombre ,
          Precio:"Precio: $"+ prod.Price + " "+ ((prod.Moneda)?prod.Moneda:Currencies.getCurrencyDefault()),
          CodigoBarras: (prod.CodigoBarras)?prod.CodigoBarras:"NO CODE",
        });
      }

    });
    return codes;
  }

  firstPageSlotsAvailable(){
    let available = 0
    for (var i = 0; i < Number(this.filas); i++) {
      for (var c = 0; c < Number(this.columnas); c++) {
        if (i == this.filaInit - 1) {
          if (c >= this.colInit - 1) {
            available++
          }
        }else if (i > this.filaInit - 1) {
          available++
        }
      }
    }
    return Number(available)
  }

  getSlotsNeeded(totalCodes){
    // obtiene cuantas paginas necesito para el doc y cuantos codigos por pagina se generaran
    let codesByPage = Number(this.columnas) * Number(this.filas);
    let pagesNeed = 1
    let availableFirstPage = this.firstPageSlotsAvailable()
    if(availableFirstPage >= totalCodes ){
      pagesNeed = 1
    }else{
      let  otherPagesNeed =Math.ceil((totalCodes - availableFirstPage)/codesByPage)
      pagesNeed += Number(otherPagesNeed)
    }
    // guardar cuantas codigos por pagina 
    let slotsByPage = {}
    let restantcodes = totalCodes
    for (var i = 0; i < Number(pagesNeed); i++) {
      if((i+1) == 1){
        slotsByPage[i+1] = availableFirstPage
        restantcodes = restantcodes - availableFirstPage
      }else{
        let codePage = 0
        if(restantcodes >= codesByPage){
          slotsByPage[i+1] = codesByPage
          restantcodes = restantcodes - codesByPage
        }else{
          slotsByPage[i+1] = restantcodes 
        }
      }
    }
    // crear las filas necesarias Extra
    let filas = Number(this.filas) * Number(pagesNeed)

    return {
      filas:filas,
      pages:pagesNeed,
      codesByPage:slotsByPage
    }
    
  }

  async getPageCodesV2(productos) {
    let codes = this.getCodesToPrint(productos);
    let totalCodes = codes.length;
    let dataPages = this.getSlotsNeeded(totalCodes)
    let contCodes = 0;
    let cols = [];
    let codesByPage = Number(this.columnas) * Number(this.filas);
    let x = 12;
    let y = 36;
    let counterFilaByPage = 0
    let counterPages = 0
    for (var i = 0; i < Number(dataPages.filas); i++) {
      let dataFila = [];
      for (var c = 0; c < Number(this.columnas); c++) {
        
        let stack = ["       "];
        if (i == this.filaInit - 1) {
          if (c >= this.colInit - 1) {
            
            if (codes[contCodes]) {
              let barcode = await this.genData(codes[contCodes].CodigoBarras);
              stack = [
                codes[contCodes].Nombre,
                codes[contCodes].Precio,
                {
                  width: (this.w * this.inch) - 75,
                  height: (this.h * this.inch) - 35 ,
                  alignment: "center",
                  image: barcode,
                },
              ];
              contCodes ++
            }else{
              let stack = ["       "];
            }
            
          }
        } else if (i > this.filaInit - 1) {
          if (codes[contCodes]) {
            let barcode = await this.genData(codes[contCodes].CodigoBarras);
            stack = [
              codes[contCodes].Nombre,
              codes[contCodes].Precio,
              {
                width: (this.w * this.inch) - 75,
                height: (this.h * this.inch) - 35 ,
                alignment: "center",
                image: barcode,
              },
            ];
            contCodes++
          }else{
            let stack = ["       "];
          }
          
        }
        dataFila.push({
          absolutePosition: { x: x, y: y },
          table: {
            widths: [this.w * this.inch],
            heights: this.h * this.inch,
            body: [
              [
                {
                  stack: stack,
                  margin: [8, 8, 8, 8],
                  border: [false, false, false, false],
                  fontSize: 10,
                },
              ],
            ],
          },
        });
        x = x + this.w * this.inch;
        x = x + 8.64;
      }
      x = 12;
      cols.push(dataFila);
      y = y + this.h * this.inch;
      counterFilaByPage++
      if(counterFilaByPage == Number(this.filas) && (counterPages + 1) != dataPages.pages ){
        counterPages ++
        cols.push({text: '', pageOrientation: 'portrait', pageBreak: 'after'});
        x = 12
        y = 36
        counterFilaByPage = 0
      }
    }
    return cols;
  }
}
